import { Checkbox } from '@rocketlane/ui';
import { defaultTheme, components as SelectComponents } from 'react-select';
import styled from 'styled-components';
import { SingleLineEllipsis } from '../../styles';

const StyledOption = styled(SelectComponents.Option).attrs({
  theme: {
    ...defaultTheme,
    borderRadius: 0,
  },
})`
  padding: var(--spacing-01) var(--spacing-05);
  height: 32px;
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  min-width: 0;
  overflow: hidden;
  border-radius: var(--border-radius-default);
  &:hover {
    background-color: var(--cell-hover);
  }
  cursor: pointer;
  &.ozone-select__option--is-selected {
    background-color: var(--blue-20);
    color: inherit;
    &:hover {
      background-color: var(--blue-20);
    }
  }
  &.ozone-select__option--is-focussed {
    background-color: var(--gray-10);
    color: inherit;

    &:hover {
      background-color: var(--gray-10);
    }
  }
`;
const CheckboxWrapper = styled.div`
  padding: var(--spacing-01);
  pointer-events: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

const OptionLabel = styled.span`
  flex: 1;
  min-width: 0;
  ${SingleLineEllipsis};
`;

/**
 * if you want to extend this to include different types, please check the implementation of virtualized-menu-list.tsx as well
 */
export const Option = (props) => {
  const label = props.data.label;
  const title = typeof label === 'string' ? label : undefined;

  return (
    <StyledOption {...props} title={title}>
      <CheckboxWrapper>
        <Checkbox
          checked={props.isSelected}
          aria-label={title}
          color={props.selectProps?.checkboxColor}
        />
        <OptionLabel>{label}</OptionLabel>
      </CheckboxWrapper>
    </StyledOption>
  );
};
